var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyRank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0938 10.1411L13.4896 8.94775L18.6807 19.39L14.8872 17.9977L11.0938 10.1411Z",
    fill: "#F98586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54883 11.3842L10.8449 10.2405L14.8879 17.9976L13.7399 21.8264L8.54883 11.3842Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2471 10.5887L11.8443 9.79309L16.1369 18.4452L14.8891 17.9977L14.5397 19.2408L10.2471 10.5887Z",
    fill: "#C10655"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59868 10.141L5.20279 8.94763L0.0117188 19.3898L3.75528 17.9976L7.59868 10.141Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.095 11.3842L7.79891 10.2405L3.75586 17.9976L4.9538 21.8264L10.095 11.3842Z",
    fill: "#F98586"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44749 10.5887L6.85024 9.79309L2.55762 18.4452L3.75556 17.9977L4.15487 19.2408L8.44749 10.5887Z",
    fill: "#C10655"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34476 0.146484C10.0436 0.146484 10.0935 1.24043 10.6924 1.33988C11.2914 1.48905 11.9902 0.643733 12.4894 0.842632C13.1382 1.14098 12.689 2.13548 13.1881 2.53328C13.6873 2.93107 14.6856 2.43383 15.035 2.88135C15.4842 3.42832 14.6856 4.12447 14.9351 4.67144C15.1847 5.21842 16.3327 5.21842 16.4825 5.76539C16.6322 6.41181 15.584 6.71016 15.584 7.35658C15.584 7.95328 16.5823 8.45053 16.4825 8.9975C16.3327 9.64393 15.2845 9.49475 14.9851 10.0417C14.7355 10.5887 15.4343 11.4837 15.035 11.9313C14.6357 12.4782 13.7372 11.8318 13.2381 12.2296C12.7389 12.6274 12.9885 13.7214 12.4894 13.97C11.8904 14.2683 11.3413 13.3236 10.7424 13.4727C10.1434 13.6219 9.89381 14.7159 9.29484 14.7159C8.59604 14.7159 8.54613 13.6219 7.94716 13.5225C7.34819 13.3733 6.64939 14.2683 6.10033 14.0197C5.50136 13.7214 5.90068 12.7269 5.40153 12.3291C4.90239 11.9313 3.90411 12.4285 3.55471 11.981C3.15539 11.434 3.95402 10.7379 3.65454 10.1909C3.50479 9.5942 2.35677 9.5942 2.20702 9.04723C2.05728 8.40081 3.10548 8.10246 3.10548 7.45603C3.10548 6.85934 2.1072 6.36209 2.20702 5.81511C2.35677 5.16869 3.40497 5.31787 3.70445 4.77089C4.00394 4.22392 3.30514 3.32887 3.65454 2.88135C4.05385 2.33438 4.95231 2.9808 5.45145 2.583C5.95059 2.1852 5.70102 1.09126 6.20016 0.842632C6.79913 0.544283 7.34819 1.48905 7.94716 1.33988C8.49621 1.24043 8.74579 0.146484 9.34476 0.146484Z",
    fill: "#FFDF66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34526 12.5279C12.1904 12.5279 14.4864 10.2405 14.4864 7.4062C14.4864 4.57189 12.1904 2.28455 9.34526 2.28455C6.50016 2.28455 4.2041 4.57189 4.2041 7.4062C4.2041 10.2405 6.50016 12.5279 9.34526 12.5279Z",
    fill: "#FFC63B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34536 12.13C11.9409 12.13 14.0872 9.9918 14.0872 7.40611C14.0872 4.82042 11.9409 2.68225 9.34536 2.68225C6.74983 2.68225 4.60352 4.82042 4.60352 7.40611C4.60352 9.9918 6.74983 12.13 9.34536 12.13Z",
    fill: "#FFDF66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1749 7.82474C14.1749 10.4088 12.0802 12.5036 9.49635 12.5036C6.91247 12.5036 4.81779 10.4088 4.81779 7.82474C4.81779 5.24068 6.91247 3.14592 9.49635 3.14592C12.0802 3.14592 14.1749 5.24068 14.1749 7.82474Z",
    fill: "url(#paint0_linear)",
    stroke: "white",
    strokeWidth: 0.578947
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17518 6.56775C8.20427 6.37509 8.25879 6.20606 8.33876 6.06065C8.41874 5.91525 8.5187 5.79438 8.63866 5.69805C8.75862 5.60172 8.89493 5.52993 9.04761 5.48267C9.2021 5.4336 9.3684 5.40906 9.54652 5.40906C9.73555 5.40906 9.90458 5.43633 10.0536 5.49085C10.2045 5.54356 10.3317 5.61626 10.4353 5.70896C10.5389 5.80165 10.618 5.9098 10.6725 6.03339C10.7288 6.15698 10.757 6.28966 10.757 6.43143C10.757 6.55684 10.7434 6.66771 10.7161 6.76404C10.6907 6.85856 10.6516 6.94125 10.5989 7.01214C10.548 7.08302 10.4844 7.143 10.408 7.19207C10.3335 7.24115 10.2472 7.28204 10.149 7.31476C10.6034 7.4638 10.8306 7.76642 10.8306 8.22262C10.8306 8.42437 10.7934 8.60249 10.7188 8.75698C10.6443 8.90965 10.5444 9.03779 10.4189 9.14139C10.2935 9.24499 10.1472 9.32314 9.98001 9.37585C9.81461 9.42674 9.64103 9.45219 9.45928 9.45219C9.26662 9.45219 9.09668 9.43038 8.94946 9.38676C8.80224 9.34314 8.67228 9.27771 8.5596 9.19046C8.44873 9.10322 8.3533 8.99417 8.27333 8.86331C8.19336 8.73063 8.12338 8.57613 8.06341 8.39983L8.39602 8.26352C8.48326 8.22717 8.56414 8.21717 8.63866 8.23353C8.715 8.24988 8.76952 8.28987 8.80224 8.35348C8.83859 8.42255 8.87676 8.48617 8.91674 8.54433C8.95855 8.60249 9.00489 8.65338 9.05578 8.697C9.10668 8.7388 9.16393 8.77152 9.22754 8.79515C9.29297 8.81878 9.36749 8.83059 9.4511 8.83059C9.55652 8.83059 9.6483 8.81332 9.72646 8.77879C9.80461 8.74426 9.87004 8.69973 9.92275 8.6452C9.97546 8.58886 10.0145 8.52615 10.04 8.45709C10.0672 8.3862 10.0809 8.31623 10.0809 8.24716C10.0809 8.15628 10.0727 8.07449 10.0563 8.00179C10.04 7.92727 10.0018 7.86457 9.94184 7.81367C9.88368 7.76097 9.79643 7.72098 9.68011 7.69372C9.56561 7.66464 9.4093 7.6501 9.21118 7.6501V7.12119C9.37658 7.12119 9.51199 7.10756 9.61741 7.0803C9.72282 7.05303 9.80552 7.01486 9.8655 6.96579C9.92548 6.91672 9.96637 6.85765 9.98818 6.78858C10.0118 6.71951 10.0236 6.64408 10.0236 6.5623C10.0236 6.38963 9.97819 6.25786 9.88731 6.16698C9.79825 6.0761 9.67102 6.03066 9.50563 6.03066C9.43293 6.03066 9.36568 6.04157 9.30388 6.06338C9.2439 6.08337 9.18937 6.11154 9.1403 6.1479C9.09304 6.18425 9.05215 6.22696 9.01762 6.27603C8.98308 6.32511 8.95764 6.37872 8.94128 6.43688C8.90675 6.52776 8.86222 6.58865 8.80769 6.61955C8.75316 6.64863 8.6741 6.65499 8.5705 6.63863L8.17518 6.56775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 6.90558,
    y: 4.83011,
    width: 5.083,
    height: 6.35892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.578947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.578947
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.49635,
    y1: 2.85645,
    x2: 9.49635,
    y2: 12.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462A0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyRank3);
export default __webpack_public_path__ + "static/media/trophy-rank-3.1b78fcd9bc71cb0a555277558013f2d9.svg";
export { ForwardRef as ReactComponent };